import TableActionMenu from "./TableActions/TableActionMenu";
import warning from "../../assets/svg/warning.svg";
import approve from "../../assets/svg/approve.svg";
import promoCode from "../../assets/svg/promoCode.svg";

import wallet from "../../assets/svg/fund_wallet.svg";
import gift from "../../assets/svg/gift.svg";
import watch from "../../assets/svg/view.svg";
import refferalCampaign from "../../assets/svg/refferal_campaign.svg";
import { Box, Typography } from "@mui/material";
import dayjs from "dayjs";

export const generateUserColumns = (actions) => {
  return [
    {
      name: "Name",
      // grow: 1.5,
      selector: (row) => row.name,
      cell: (row) => {
        return (
          <>
            {row.profileImage ? (
              <img
                src={row.profileImage}
                style={{ width: "24px", height: "24px", borderRadius: "50%" }}
                staticImage
                alt={row.name}
              />
            ) : (
              <div
                style={{
                  width: "24px",
                  height: "24px",
                  borderRadius: "50%",
                  backgroundColor: "#8770DE",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  color: "#fff",
                  fontSize: "16px",
                }}
              >
                {row.name.charAt(0).toUpperCase()}
              </div>
            )}
            <Typography sx={{ fontSize: "14px", fontWeight: 500, ml: 1 }}>
              {row.name}
            </Typography>
          </>
        );
      },
      // sortable: true,
    },
    {
      name: "Joined Date",
      selector: (row) => row.createdAt,
      // grow: 1.5,
      cell: (row) => (
        <Typography sx={{ fontSize: "14px", fontWeight: 500 }}>
          {new Date(row?.createdAt?.seconds * 1000).toDateString()}
        </Typography>
      ),
      // sortable: true,
      // hide: "lg",
    },
    {
      name: "Country",
      selector: (row) => row.country,
      // grow: 1.5,
      cell: (row) => (
        <Typography sx={{ fontSize: "14px", fontWeight: 500 }}>
          {row.country}
        </Typography>
      ),
      // sortable: true,
      // hide: "md",
    },
    {
      name: "Phone No.",
      selector: (row) => row.phoneNumber,
      // grow: 1.5,
      cell: (row) => {
        return (
          <>
            <Typography sx={{ fontSize: "14px", fontWeight: 500, mr: 0.5 }}>
              <span>(+{row.phoneCode})&nbsp;</span>
              <span>{row.phoneNumber}</span>
            </Typography>
            <img
              src={row?.phoneVerified === "warning" ? warning : approve}
              alt="status"
              width="16px"
              height="16px"
            />
          </>
        );
      },
      // sortable: true,
      // hide: "md",
    },
    {
      name: "Email",
      selector: (row) => row.emailId,
      // grow: 1.5,
      cell: (row) => {
        return (
          <>
            <Typography sx={{ fontSize: "14px", fontWeight: 500, mr: 0.5 }}>
              {row.emailId}
            </Typography>
            <img
              src={row?.emailVerified === "approve" ? approve : warning}
              alt="status"
              width="16px"
              height="16px"
            />
          </>
        );
      },
      // sortable: true,
      // hide: "md",
    },
    {
      name: "Last login",
      selector: (row) => row.lastLoginAt,
      // grow: 1.5,
      cell: (row) => (
        <Typography sx={{ fontSize: "14px", fontWeight: 500 }}>
          {new Date(row?.lastLoginAt?.seconds * 1000).toDateString()}
        </Typography>
      ),
      // sortable: true,
      // hide: "md",
    },
    {
      name: "Status",
      selector: (row) => row.status,
      grow: 0,
      cell: (row) => {
        return (
          row?.status && (
            <span
              style={{
                fontSize: "14px",
                fontWeight: 500,
                padding: "4px 8px",
                backgroundColor:
                  row.status === "Active" ? "#2DC58C" : "#EB5757",
                borderRadius: "2px",
                color: "white",
              }}
            >
              {row.status}
            </span>
          )
        );
      },
    },
    {
      name: "action",
      grow: 0,
      cell: (row) => {
        const updatedAction = actions.filter((act) => {
          if (act.actionName === "Unblock") {
            if (row.status === "Blocked") {
              return act;
            }
          } else if (act.actionName === "Block") {
            if (row.status === "Active") {
              return act;
            }
          } else {
            return act;
          }
        });

        return <TableActionMenu row={row} updatedActionList={updatedAction} />;
      },
      sortable: false,
      // hide: "md",
    },
  ];
};

export const UserIssuesColumns = [
  {
    name: "Date",
    grow: 1,
    selector: (row) => row?.createdAt,
    cell: (row) => (
      <span>{new Date(row?.createdAt?.seconds * 1000).toDateString()}</span>
    ),
    // sortable: true,
    // hide: "lg",
  },
  {
    name: "RouterPartner Name",
    grow: 2,
    selector: (row) => row.routePartnerName,
    cell: (row) => <span>{row?.routePartnerName}</span>,
  },
  {
    name: "Customer Name",
    grow: 1,
    selector: (row) => row.customerName,
    cell: (row) => (
      // <a
      //   // href="#"
      //   onClick={() => {
      //     const userId = row?.userId;
      //     const newURL = `/systems/user/view/${userId}`;
      //     window.location.href = newURL;
      //   }}
      //   className="text-info"
      // >
      //   {row?.userName}
      // </a>
      <span>{row?.customerName}</span>
    ),
    // <a href={`systems/user/view/${""}`} className="text-info">{row.userName}</a>
    // sortable: true,
    // hide: "md",
  },
  {
    name: "Order Number",
    grow: 1,
    selector: (row) => row.orderNumber,
    cell: (row) => <span>{row.orderNumber}</span>,
    // sortable: true,
    // hide: "md",
  },
  {
    name: "Issue Type",
    grow: 1,
    selector: (row) => row.issueType,
    cell: (row) => <span>{row.issueType}</span>,
    // sortable: true,
    // hide: "md",
  },
  {
    name: "Note",
    grow: 4,
    selector: (row) => row.describeIssue,
    center: true,
    cell: (row) => <span>{row.describeIssue}</span>,
    // sortable: true,
    // hide: "lg",
  },
];

const makeCampaignTypeProper = (type) => {
  const typeArr = type.split("_");
  return typeArr.join(" ");
};

export const generateTopUpHistoryColumns = (actions) => {
  return [
    {
      name: "Added On",
      selector: (row) => row.createdAt,
      // grow: 1.5,
      cell: (row) => {
        let dateVal = "-";
        if (row?.createdAt) {
          if (row.createdAt.seconds) {
            dateVal = dayjs(new Date(row.createdAt.seconds * 1000)).format(
              "DD-MM-YYYY",
            );
          } else if (typeof row.createdAt.toDate === "function") {
            dateVal = dayjs(row.createdAt.toDate()).format("DD-MM-YYYY");
          } else {
            dateVal = dayjs(row.createdAt).format("DD-MM-YYYY");
          }
        }
        return (
          <Typography sx={{ fontSize: "14px", fontWeight: 500 }}>
            {dateVal}
          </Typography>
        );
      },
      // sortable: true,
      // hide: "lg",
    },
    {
      name: "Type",
      selector: (row) => row.campaignType,
      // grow: 1.5,
      cell: (row) => (
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            padding: "5px",
            border: "1px solid rgba(229, 229, 232, 1)",
            borderRadius: "4px",
          }}
        >
          <img
            src={
              row?.campaignType === "fund_wallet"
                ? wallet
                : row?.campaignType === "gift_certificate"
                  ? gift
                  : row?.campaignType === "promo_code"
                    ? promoCode
                    : refferalCampaign
            }
            alt="campaign type"
            width="18px"
            height="18px"
          />
          <Typography
            sx={{
              fontSize: "14px",
              fontWeight: 500,
              marginLeft: "10px",
              textTransform: "capitalize",
            }}
          >
            {makeCampaignTypeProper(row?.campaignType || "")}
          </Typography>
        </Box>
      ),
      // sortable: true,
      // hide: "md",
    },
    {
      name: "Email",
      selector: (row) => row.emails,
      // grow: 1.5,
      cell: (row) => {
        let emailsDisplay = " - ";
        if (row?.forAllUsers) {
          emailsDisplay = "All Users";
        } else if (row?.forAllCustomers) {
          emailsDisplay = "All Customers";
        } else if (row?.emails?.length > 0) {
          emailsDisplay = row.emails.map((e) => e?.email || e).join(", ");
        }
        return (
          <Typography sx={{ fontSize: "14px", fontWeight: 500, mr: 0.5 }}>
            {emailsDisplay}
          </Typography>
        );
      },
      // sortable: true,
      // hide: "md",
    },
    {
      name: "Total Value",
      selector: (row) => row.maxDisAmount,
      // grow: 1.5,
      cell: (row) => {
        let val = "-";
        let isPercentage = false;

        if (row?.campaignType === "fund_wallet") {
          val = row?.amount;
        } else if (row?.campaignType === "promo_code") {
          val = row?.totalDiscount;
          isPercentage = true;
        } else if (row?.campaignType === "referral_campaign") {
          val = row?.referralBonus;
          isPercentage = true;
        }

        let displayVal = "-";
        if (val !== "-" && val !== undefined && val !== "") {
          displayVal = isPercentage ? `${Number(val)}%` : `$${Number(val)}`;
        }

        return (
          <Typography sx={{ fontSize: "14px", fontWeight: 500 }}>
            {displayVal}
          </Typography>
        );
      },
      // sortable: true,
      // hide: "md",
    },
    {
      name: "View",
      selector: (row) => row.view,
      // grow: 1.5,
      cell: (row) => (
        <img src={watch} alt="status" width="18px" height="18px" />
      ),
      // sortable: true,
      // hide: "md",
    },
    {
      name: "Expired Date",
      selector: (row) => row.expiryDate,
      // grow: 1.5,
      cell: (row) => {
        let expiryDateStr = "-";
        if (row?.isNeverExpire) {
          expiryDateStr = "Never Expire";
        } else if (row?.expiryDate) {
          let ed = row.expiryDate;
          if (ed?.seconds) {
            expiryDateStr = dayjs(new Date(ed.seconds * 1000)).format(
              "DD-MM-YYYY",
            );
          } else if (typeof ed?.toDate === "function") {
            expiryDateStr = dayjs(ed.toDate()).format("DD-MM-YYYY");
          } else {
            expiryDateStr = dayjs(ed).format("DD-MM-YYYY");
          }
        }
        return (
          <Typography sx={{ fontSize: "14px", fontWeight: 500 }}>
            {expiryDateStr}
          </Typography>
        );
      },
      // sortable: true,
      // hide: "lg",
    },
    {
      name: "Status",
      selector: (row) => row.status,
      grow: 0,
      cell: (row) => {
        // const displayStatus = row?.status || "Active";
        const displayStatus = row?.status;
        const isActive = displayStatus?.toLowerCase() === "active";
        return (
          <span
            style={{
              fontSize: "14px",
              fontWeight: 500,
              padding: "4px 8px",
              // backgroundColor: isActive ? "#2DC58C" : "#EB5757",
              backgroundColor: isActive ? "#2DC58C" : "",
              borderRadius: "2px",
              color: "white",
              textTransform: "capitalize",
            }}
          >
            {displayStatus}
          </span>
        );
      },
    },
    // {
    //   name: "action",
    //   grow: 0,
    //   cell: (row) => {
    //     const updatedAction = actions.filter((act) => {
    //       if (act.actionName === "Unblock") {
    //         if (row.status === "Blocked") {
    //           return act;
    //         }
    //       } else if (act.actionName === "Block") {
    //         if (row.status === "Active") {
    //           return act;
    //         }
    //       } else {
    //         return act;
    //       }
    //     });
    //     return <TableActionMenu row={row} updatedActionList={updatedAction} />;
    //   },
    //   sortable: false,
    //   // hide: "md",
    // },
  ];
};

export const generateFundWalletColumns = () => {
  return [
    ...generateTopUpHistoryColumns().filter(
      (col) =>
        col.name === "Added On" ||
        col.name === "Email" ||
        col.name === "Total Value" ||
        col.name === "View",
    ),
  ];
};

export const generatePromoCodeColumns = () => {
  return [
    ...generateTopUpHistoryColumns().filter((col) => col.name === "Added On"),
    {
      name: "Promo Code",
      selector: (row) => row.promoCode,
      cell: (row) => (
        <Typography sx={{ fontSize: "14px", fontWeight: 500 }}>
          {row?.promoCode || "-"}
        </Typography>
      ),
    },
    ...generateTopUpHistoryColumns().filter((col) => col.name === "Email"),
    {
      name: "Used For",
      selector: (row) => row.usedFor,
      cell: (row) => (
        <Typography
          sx={{
            fontSize: "14px",
            fontWeight: 500,
            textTransform: "capitalize",
          }}
        >
          {row?.usedFor || "-"}
        </Typography>
      ),
    },
    {
      name: "Total Discount",
      selector: (row) => row.totalDiscount,
      cell: (row) => (
        <Typography sx={{ fontSize: "14px", fontWeight: 500 }}>
          {row?.totalDiscount ? `${row.totalDiscount}%` : "-"}
        </Typography>
      ),
    },
    {
      name: "Max Discount",
      selector: (row) => row.maxDisAmount,
      cell: (row) => (
        <Typography sx={{ fontSize: "14px", fontWeight: 500 }}>
          {row?.maxDisAmount
            ? `$${row.maxDisAmount}`
            : row?.isNoMaxAmount
              ? "No Max"
              : "-"}
        </Typography>
      ),
    },
    ...generateTopUpHistoryColumns().filter(
      (col) =>
        col.name === "Expired Date" ||
        col.name === "Status" ||
        col.name === "View",
    ),
  ];
};

export const generateReferralCampaignColumns = () => {
  return [
    ...generateTopUpHistoryColumns().filter((col) => col.name === "Added On"),
    ...generateTopUpHistoryColumns().filter((col) => col.name === "Email"),
    {
      name: "Referral Bonus",
      selector: (row) => row.referralBonus,
      cell: (row) => (
        <Typography sx={{ fontSize: "14px", fontWeight: 500 }}>
          {row?.referralBonus ? `${row.referralBonus}%` : "-"}
        </Typography>
      ),
    },
    {
      name: "Friend Bonus",
      selector: (row) => row.friendReferalBonus,
      cell: (row) => (
        <Typography sx={{ fontSize: "14px", fontWeight: 500 }}>
          {row?.friendReferalBonus ? `${row.friendReferalBonus}%` : "-"}
        </Typography>
      ),
    },
    {
      name: "Max Amount",
      selector: (row) => row.maxReferralAmount,
      cell: (row) => (
        <Typography sx={{ fontSize: "14px", fontWeight: 500 }}>
          {row?.maxReferralAmount ? `$${Number(row.maxReferralAmount)}` : "-"}
        </Typography>
      ),
    },
    ...generateTopUpHistoryColumns().filter(
      (col) =>
        col.name === "Expired Date" ||
        col.name === "Status" ||
        col.name === "View",
    ),
  ];
};
